import { FC, ReactNode } from 'react';
import { Box } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { Slide } from '../../state';
import { LoginForm } from './LoginForm';
import { LoginSlider } from './LoginSlider';

/**
 * Initial screen where login happens
 */
type Props = {
  slides: Slide[];
  titleLoginForm: string;
  subTitleLoginForm: string;
  logoLoginForm?: string;
  logoWidth?: number;
  childrenLogin?: ReactNode;
};

export const Login: FC<Props> = ({
  slides,
  titleLoginForm,
  subTitleLoginForm,
  logoLoginForm,
  logoWidth,
  childrenLogin,
}) => {
  const { genericResponsiveValue } = useResponsiveStyle();

  return (
    <Box
      display='flex'
      backgroundColor='primary/background'
      height='100vh'
      flexDirection='row'
      flex={1}
    >
      <Box
        flex={2}
        justifyContent='center'
        display={genericResponsiveValue({
          breakPoints: { tablet: 'none', mobile: 'none' },
          defaultValue: 'flex',
        })}
        alignItems='center'
      >
        <Box
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, #000000 0%, #340AE2 20%)',
            clipPath: 'polygon(0px 0px, 0% 0px, 60% 100%, 0% 100%)',
            zIndex: 0,
          }}
        />
        <LoginSlider slides={slides} />
      </Box>
      <Box flex={1} position='relative'>
        <LoginForm
          logoWidth={logoWidth}
          logo={logoLoginForm}
          title={titleLoginForm}
          subTitle={subTitleLoginForm}
          childrenLogin={childrenLogin}
        />
      </Box>
    </Box>
  );
};
